import { getRequest } from '../../../services/api';
import type { ApiResponse } from '../../../services/types';
import { FALLBACK_COUNTRY } from '../constants';
import type { Country } from '../types';

import { makeGeoDataApi } from './makeGeoDataApi';

export const countriesApi = makeGeoDataApi<Country, []>(
  () =>
    getRequest<ApiResponse<Country[]>>('/v2/geography/countries', { filterByCountry: true }).then(
      (res) => res.data.data,
    ),
  () => 'countries',
  (country) => country.code,
);

export function useSingleCountryData(countryCode: string) {
  const [fullCountriesData, isFetching] = countriesApi.useFullGeoData();

  return { country: fullCountriesData.map[countryCode] || FALLBACK_COUNTRY, isFetching };
}

export function useCountriesData() {
  return countriesApi.useFullGeoData();
}
